import { HttpStatusCode } from 'axios'
import dayjs from 'dayjs'
import { create } from 'zustand'

type AuthCodeStore = {
  countdownDate: Date
  setCountdownDate: (seconds: number) => void

  errorStatus?: HttpStatusCode
  setErrorStatus: (status?: HttpStatusCode) => void

  errorTitle?: string
  setErrorTitle: (title?: string) => void
}

export const useAuthCodeStore = create<AuthCodeStore>(set => ({
  countdownDate: new Date(),
  setCountdownDate: seconds =>
    set(() => ({
      countdownDate: dayjs().add(seconds, 'seconds').toDate()
    })),

  errorStatus: undefined,
  setErrorStatus: errorStatus => set(() => ({ errorStatus })),

  errorTitle: undefined,
  setErrorTitle: errorTitle => set(() => ({ errorTitle }))
}))
